import store from '@/store/index';
import { DoorConfiguration as contex } from '../DoorConfiguration';
import { ValueDefinition } from '@/configurator/types';

export const defaultValueObject = {
    id: 0,
    description: '',
    value: '',
    resource: '',
    default: 0,
};

export const GetDependencyValueCode = (characteristicCode: string, context: number): string => {
    let value;

    //const doorConfiguration = store.getters.getCurrentDoorConfiguration;
    const doorConfiguration = store.state.configuratorModule.doorConfiguration;
    const contextCharacteristics = doorConfiguration.Get(context);
    const characteristicValue = contextCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    if (typeof characteristicValue !== 'undefined') {
        value = characteristicValue.value.value;
    } else {
        value = '0';
    }

    return value;
};

// Returns value object of a characteristic. Used for special textual characteristics like KTU_MM_SCHLAG_O_SO_BS
export const GetDependencyValueCodeObject = (characteristicCode: string, context: number): ValueDefinition => {
    let value;

    //const doorConfiguration = store.getters.getCurrentDoorConfiguration;
    const doorConfiguration = store.state.configuratorModule.doorConfiguration;
    const contextCharacteristics = doorConfiguration.Get(context);
    const characteristicValue = contextCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    if (typeof characteristicValue !== 'undefined') {
        value = characteristicValue.value;
    } else {
        value = copyObject(defaultValueObject);
    }

    return copyObject(value);
};

export const GetMainCharacteristicValue = (characteristicCode: string, context: number): number => {
    let value;
    //const doorConfiguration = store.getters.getCurrentDoorConfiguration;
    const doorConfiguration = store.state.configuratorModule.doorConfiguration;
    const frameCharacteristics = doorConfiguration.Get(context);
    const characteristicValue = frameCharacteristics.filter((x: any) => x.code === characteristicCode)[0];
    value = typeof characteristicValue !== 'undefined' ? Number(characteristicValue.value.value) : 0;

    return value;
};

export const HasTopPanel = (): boolean => {
    //return store.getters.getCurrentDoorConfiguration.GetHasTopPannel();
    return store.state.configuratorModule.doorConfiguration.GetHasTopPannel();
};

export const GetCharacteristicProperty = (characteristicCode: string, property: string) => {
    let value: number = 0;
    const charcateristicValue = GetCharacteristicValue(characteristicCode);
    const materialValue = GetPropertyValue(charcateristicValue, property);
    value = materialValue;
    return value;
};

const GetCharacteristicValue = (characteristicCode: string) => {
    let characteristicValue;
    //const doorConfiguration = store.getters.getCurrentDoorConfiguration;
    const doorConfiguration = store.state.configuratorModule.doorConfiguration;
    const frameCharacteristics = doorConfiguration.Get(contex.Frame);
    const filteredCharacteristicValue = frameCharacteristics.filter((x: any) => x.code === characteristicCode)[0];

    characteristicValue = filteredCharacteristicValue.value.value;
    return characteristicValue;
};

const GetPropertyValue = (materialCode: string, property: string) => {
    let material: any;
    const materials = store.getters['measureModule/getMaterials'];
    material = typeof materials !== 'undefined' ? materials.filter((x: any) => x.code === materialCode)[0] : undefined;
    const materialProperty = typeof material !== 'undefined' ?  material.childCharacteristics.filter((x: any) => x.property === property)[0] : undefined;
    return typeof materialProperty !== 'undefined' ? materialProperty.value : 0;
};

export default function copyObject(src: any) {
    return Object.assign({}, src);
}